

import { Injectable, Optional } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { NbToastrService } from '@nebular/theme';
import { catchError, switchMap } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MasterService {
  getAllUsers() {
    throw new Error('Method not implemented.');
  }

  manage_projects_customerData: any = []
  selectedCustomerIds: any = [];
  filteredCustomerList: any = []
  smartsyncTableList: any = []
  smartsyncformdata: any = {}
  FinalMoqData: any = []
  FinalMoqD: any = {}
  showMOQSection: boolean = false
  smartsyncTabContainer: string = "syncVolumeContainer"
  testBack = new Subject<any>();
  testBackSend(data: any) {
    this.testBack.next(data)
  }
  testBackrecive() {
    return this.testBack.asObservable()
  }
  tablereprestation: any = {}



  baseUrl = environment.apiUrl;
  private readonly demoRfqAuthUrl = 'https://demo-tras.getapcs.com:8040/api/Login/GenerateUserToken';
  private readonly demoRfqReleasedListUrl = 'https://demo-tras.getapcs.com:8043/api/Rfq/GetSoucingFGBomChildItemDetails';
  private readonly demoRfqUpdateUrl = 'https://demo-tras.getapcs.com:8043/api/RfqSourcing/UpdateSoucingRfqSourcing';

  private readonly trassconRfqAuthUrl = 'https://trasccon.getapcs.com:8003/api/Login/GenerateUserToken';
  private readonly trassconRfqReleasedListUrl = 'https://trasccon.getapcs.com:8006/api/Rfq/GetSoucingFGBomChildItemDetails';
  private readonly trassconRfqUpdateUrl = 'https://trasccon.getapcs.com:8006/api/RfqSourcing/UpdateSoucingRfqSourcing';

  private get rfqConfig() {
    const currentBaseUrl = (this.baseUrl || '').toLowerCase();
    const isTrassconInstance = currentBaseUrl.includes('trasccon') || currentBaseUrl.includes('trasscon');

    return isTrassconInstance
      ? {
          authUrl: this.trassconRfqAuthUrl,
          releasedListUrl: this.trassconRfqReleasedListUrl,
          updateUrl: this.trassconRfqUpdateUrl
        }
      : {
          authUrl: this.demoRfqAuthUrl,
          releasedListUrl: this.demoRfqReleasedListUrl,
          updateUrl: this.demoRfqUpdateUrl
        };
  }

  constructor(
    private httpClient: HttpClient,
    @Optional() private notify: NbToastrService
  ) { }

  // =====================================================================
  // GET METHODS
  // =====================================================================

  getAllProjectViewInfoData(user_id: number): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/getAlldetails/${user_id}`);
  }

  engineers(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/engineers`);
  }

  get_frequency(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/get_frequency`);
  }

  fetchNotifications(userId: number | string): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/fetch_notifications/${userId}`);
  }

  markNotificationRead(notificationId: number | string): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/mark_notification_read/${notificationId}`, { notification_id: notificationId });
  }

  calculate_freight_matrix(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/calculate_freight_matrix`);
  }

  calculate_duty_matrix(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/calculate_duty_matrix`);
  }

  getSuppliers(skip: number = 0, limit: number = 10): Observable<any> {
    let url = `${this.baseUrl}/suppliers?skip=${skip}&limit=${limit}`;
    return this.httpClient.get(url);
  }

  getSupplierById(supplierId: string): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/suppliers/${supplierId}`);
  }

  getPurchaseOrders(skip = 0, limit = 10, supplierId?: string): Observable<any[]> {
    let url = `${this.baseUrl}/purchase-orders?skip=${skip}&limit=${limit}`;
    if (supplierId) {
      url += `&supplier_id=${supplierId}`;
    }
    return this.httpClient.get<any[]>(url);
  }

  getEmailTemplateCategories(skip: number = 0, limit: number = 50): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrl}/email-template-categories?skip=${skip}&limit=${limit}`);
  }

  // getOfflineVendorSourcing(project_id: string, version_id: string): Observable<any> {
  //   return this.httpClient.get(`${this.baseUrl}/offline_vendor_sourcing/${project_id}/${version_id}`);
  // }
  getOfflineVendorSourcing(project_id: string, version_id: number, procurement_version_id: number = 0): Observable<any> {

    return this.httpClient.get(
      `${this.baseUrl}/offline_vendor_sourcing/${project_id}/${version_id}/${procurement_version_id}`
    );
  }
  getEmailTemplates(skip: number = 0, limit: number = 10, category: string = ''): Observable<any> {
    let url = `${this.baseUrl}/email-templates?skip=${skip}&limit=${limit}`;
    if (category) {
      url += `&category=${category}`;
    }
    return this.httpClient.get<any>(url);
  }

  getCategories(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/email_templates`);
  }

  getEmailTemplatesid(templateName: string): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/email_templates?templateName=${templateName}`);
  }

  getSampleEmailTemplate(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/email_template`);
  }

  searchSuppliers(search: string, skip: number = 0, limit: number = 10): Observable<any> {
    const url = `${this.baseUrl}/suppliers/search?search=${search}&skip=${skip}&limit=${limit}`;
    console.log('searchSuppliers =>', url);
    return this.httpClient.get(url);
  }

  getEmailTemplateCollections(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/email-template-collections`);
  }

  getEmailTemplateMetaFields(collection: string): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/email-meta-fields`, {
      params: { collection_name: collection }
    });
  }

  downloadFileWithAuth(fileId: string): Observable<Blob> {
    const url = `${this.baseUrl}/download_file/${fileId}`;
    return this.httpClient.get(url, { responseType: 'blob' });
  }

  fetchCurrencyUploadHistory(limit: number = 10): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/fetch_currency_upload_history?limit=${limit}`);
  }

  getEmailTemplatesByCategory(category: string): Observable<any> {
    const params: any = {
      skip: 0,
      limit: 10,
      category
    };
    return this.httpClient.get(`${this.baseUrl}/email-templates`, { params });
  }

  getRfqFollowups(rfqId: string): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/offline_vendor_sourcing/rfqs/${rfqId}`);
  }

  // getInputSourceDropdown(projectId: number, versionId: number): Observable<any> {
  //   return this.httpClient.get(
  //     `${this.baseUrl}/get_Input_source_data/projects/${projectId}/versions/${versionId}/dropdown-options`
  //   );
  // }
  getInputSourceDropdown(
    projectId: number,
    versionId: number,
    procurementVersionId: number = 0
  ): Observable<any> {

    return this.httpClient.get(
      `${this.baseUrl}/get_Input_source_data/projects/${projectId}/versions/${versionId}/procurement/${procurementVersionId}/dropdown-options`
    );
  }
  // =====================================================================
  // POST METHODS
  // =====================================================================

  geAllsourcingParts({ }): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_sourcingParts/`, {});
  }

  getParts_offer_details(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/getParts_offer_details/`, data);
  }

  login(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/login`, data);
  }

  add_project(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/add_project`, data);
  }

  manage_projects(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/manage_projects/`, data).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('API Request Failed:', error);
        let errorMessage = 'Something went wrong. Please try again.';
        if (error.status === 500) {
          errorMessage = 'Server error: 500 Internal Server Error. Please try again later.';
        } else if (error.status === 0) {
          errorMessage = 'Network error: Unable to reach the server.';
        } else if (error.error?.message) {
          errorMessage = error.error.message;
        }
        this.notify?.danger(errorMessage);
        return throwError(() => new Error(errorMessage));
      })
    );
  }

  add_customer(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/add_customer`, data);
  }

  all_customers(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/manage_customers/`, data);
  }

  create_customers(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/customers/create`, data);
  }

  get_manager_and_engineers(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_manager_and_engineers/`, data);
  }

  get_Projectview(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_Projectview`, payload);
  }

  get_Projectview_part(project_id: number, version_id: number): Observable<any> {
    const url = `${this.baseUrl}/get_Projectview`;
    const payload = {
      project_id,
      version_id
    };
    return this.httpClient.post(url, payload);
  }

  get_project_part_details_Top_N_Seller(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_project_part_details_Top_N_Seller`, data);
  }

  finalCompareData(parts: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/trigger_sourcing_parts_task`, parts);
  }

  getRfqEnggReleasedList(payload: { RfqNumber: string }): Observable<any> {
    const authPayload = {
      userName: 'admin@mail.com',
      password: 'AATr@ns@2026',
      unitName: 'Bangalore'
    };

    return this.httpClient.post<any>(this.rfqConfig.authUrl, authPayload).pipe(
      switchMap((tokenResponse: any) => {
        const token = this.extractGeneratedToken(tokenResponse);
        if (!token) {
          return throwError(() => new Error('Authentication token not found in token response.'));
        }

        const headers = new HttpHeaders({
          Authorization: `Bearer ${token}`
        });

        return this.httpClient.get<any>(this.rfqConfig.releasedListUrl, {
          headers,
          params: {
            RfqNumber: payload.RfqNumber
          }
        });
      })
    );
  }

  private extractGeneratedToken(response: any): string | null {
    if (!response) {
      return null;
    }

    if (typeof response === 'string') {
      return response;
    }

    return (
      response?.token ||
      response?.accessToken ||
      response?.data?.token ||
      response?.data?.accessToken ||
      response?.data?.tokenString ||
      response?.result?.token ||
      response?.result?.accessToken ||
      response?.data?.[0]?.token ||
      response?.data?.[0]?.accessToken ||
      null
    );
  }

  get_ProjectviewWithProjectIdAndVersionId(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_Projectview`, data);
  }

  get_projects_comparison_dropdown(data: any): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/get_projects_comparison_dropdown/`, { params: data });
  }

  get_offer_price(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_offer_price`, data);
  }

  add_user(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/manage_users`, data);
  }

  get_All_roles({ }): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/Getrolemaster`, {});
  }

  update_Finalise_project_part(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/UpdateFinaliseProjectPart`, data);
  }

  manufacturer_Name_search(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/manufacturer_Name_search`, data);
  }

  sync_project_part(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/sync_project_part`, data);
  }

  calculate_duty_cost(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/calculate_duty_cost/`, data);
  }

  get_sync_consolidation_parts(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/get_sync_consolidation_parts`, data);
  }

  create_part_alert(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/create_part_alert`, data);
  }

  list_parts_alert(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/list_parts_alert`, data);
  }

  save_sync_cosolidate_final_part(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/save_sync_cosolidate_final_part`, data);
  }

  fetch_sync_cosolidate_final_part(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/fetch_sync_consolidation_final_part`, data);
  }

  analyze_html(data: any): Observable<any> {
    return this.httpClient.post(`${'https://ai.syntheta.net/api/analyze/html'}`, data);
  }

  sync_project_parts_moq(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/sync_project_parts_moq`, data);
  }

  uploadPoData(parts: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/purchase-orders/upload`, parts);
  }

  uploadVendorData(parts: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/suppliers/upload`, parts);
  }

  fetchPartDetails(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/fetch-part-details`, payload);
  }

  createSupplier(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/suppliers`, payload);
  }

  uploadAttachments(internalPartNo: string, files: File[]): Observable<any> {
    const formData = new FormData();
    files.forEach((file: File) => {
      formData.append('files', file, file.name);
    });
    formData.append('internalPartNo', internalPartNo);
    return this.httpClient.post(`${this.baseUrl}/upload_files`, formData);
  }

  uploadFilesForAIScrubbing(files: File[]): Observable<any> {
    const formData = new FormData();
    files.forEach((file: File) => {
      formData.append('files', file, file.name);
    });
    return this.httpClient.post(`${this.baseUrl}/upload_files`, formData);
  }

  matchFiles(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/match`, payload);
  }

  matchEolStatus(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/match-eolstatus`, payload);
  }

  mpnCheck(payload: { mpn: string; manufacturer: string }): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/mpn-check`, payload);
  }

  submitRFQ(payload: any, sendEmail: boolean = true): Observable<any> {
    return this.httpClient.post(
      `${this.baseUrl}/offline_vendor_sourcing/create?send_email=${sendEmail}`,
      payload
    );
  }

  createEmailTemplate(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/email-templates`, payload);
  }

  getPartPriceHistoryInternal(internalPartNo: string, projectId: any, versionId: number, commodity: string, procurementVersionId: number = 0): Observable<any> {
    const body = {
      internalPartNumber: internalPartNo,
      project_id: projectId,
      version_id: versionId,
      procurement_version_id: procurementVersionId,
      commodity: commodity
    };
    return this.httpClient.post(`${this.baseUrl}/part_history_ipn`, body);
  }

  getCustomers(payload: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/customers/`, payload);
  }

  // =====================================================================
  // PUT METHODS
  // =====================================================================

  updateSupplier(supplierId: string, supplierData: any): Observable<any> {
    return this.httpClient.put(`${this.baseUrl}/suppliers/${supplierId}`, supplierData);
  }

  updateSourcingParts(payload: any): Observable<any> {
    const url = `${this.baseUrl}/offline_vendor_sourcing/parts/update`;
    return this.httpClient.put(url, payload);
  }

  updateEmailTemplate(id: string, payload: any): Observable<any> {
    return this.httpClient.put(`${this.baseUrl}/email-templates/${id}`, payload);
  }

  sendRfqEmail(rfqId: string, payload: any, sendEmailFlag: boolean): Observable<any> {
    return this.httpClient.put(
      `${this.baseUrl}/offline_vendor_sourcing/rfqs/${rfqId}?send_email_flag=${sendEmailFlag}`,
      payload
    );
  }

  updateCustomer(payload: any): Observable<any> {
    return this.httpClient.put(`${this.baseUrl}/customers/update`, payload);
  }

  // =====================================================================
  // DELETE METHODS
  // =====================================================================

  delete_part_alert(job_id: string): Observable<any> {
    return this.httpClient.delete(`${this.baseUrl}/delete_part_alert/${job_id}`);
  }

  deleteSupplier(supplierId: string): Observable<any> {
    return this.httpClient.delete(`${this.baseUrl}/suppliers/${supplierId}`);
  }

  deleteEmailTemplate(id: string): Observable<any> {
    return this.httpClient.delete(`${this.baseUrl}/email-templates/${id}`);
  }

  softDeleteCustomer(customerId: number): Observable<any> {
    return this.httpClient.delete(
      `${this.baseUrl}/customers/soft_delete/${customerId}`
    );
  }

  Delete_part(payload: any): Observable<any> {
    return this.httpClient.delete(
      `${this.baseUrl}/delete-part`,
      {
        body: payload
      }
    );
  }
  dashboardHierarchy(payload: any) {
    return this.httpClient.post<any>(
      `${this.baseUrl}/hierarchy-dashboard/dashboard`,
      payload
    );
  }
  getAgeingSummary(params: any) {
    return this.httpClient.get<any>(
      `${this.baseUrl}/hierarchy-dashboard/ageing-summary`,
      { params }
    );
  }
  getEngineerWiseProjectSummary(managerId: number) {
    return this.httpClient.get<any>(
      ` ${this.baseUrl}/hierarchy-dashboard/manager-dashboard/engineer-wise-project-summary`,
      {
        params: {
          manager_id: managerId
        }
      }
    );
  }
  getTopSuppliers(params: any) {
    return this.httpClient.get<any>(
      `${this.baseUrl}/hierarchy-dashboard/top-suppliers`,
      { params }
    );
  }

  // getImportStatusCommodityWise(params: any) {
  //   return this.httpClient.get<any>(
  //     `${this.baseUrl}/hierarchy-dashboard/import-status-commodity-wise`,
  //     { params }
  //   );
  // }

  getCompletionSummary(params: any) {
    return this.httpClient.get<any>(
      `${this.baseUrl}/hierarchy-dashboard/completion-summary`,
      { params }
    );
  }
  getMasterDataStatus() {
    return this.httpClient.get<any>(
      `${this.baseUrl}/hierarchy-dashboard/master-data-status`
    );
  }

  getOfflineOnlineSummary(params: any) {
    return this.httpClient.get(
      `${this.baseUrl}/hierarchy-dashboard/online-offline-summary`,
      { params }
    );
  }
  getSupplierPaymentSummary(params: any) {
    return this.httpClient.get(
      `${this.baseUrl}/hierarchy-dashboard/supplier-payment-summary`,
      { params }
    );
  }

  getPartPricing(params: any) {
    return this.httpClient.get(
      `${this.baseUrl}/hierarchy-dashboard/part-pricing`,
      { params }
    );
  }

  getCostByCurrency(params: any) {
    return this.httpClient.get(
      `${this.baseUrl}/hierarchy-dashboard/cost-by-currency`,
      { params }
    );
  }

  getHierarchyLeadtime(params: any) {
    return this.httpClient.get(
      `${this.baseUrl}/hierarchy-dashboard/leadtime`,
      { params }
    );
  }
  getSmartSyncSummary(params: any) {
    return this.httpClient.get(
      `${this.baseUrl}/hierarchy-dashboard/smart-sync-summary`,
      { params }
    );
  }

  getCostSavings(params: any) {
    return this.httpClient.get<any[]>(
      `${this.baseUrl}/hierarchy-dashboard/cost-savings`,
      { params: params as any }
    );
  }
  getQuantityDiff(params: any) {
    return this.httpClient.get<any>(
      `${this.baseUrl}/hierarchy-dashboard/quantity-diff`,
      { params }
    );
  }
  uploadExchangeRates(file: File) {
    const formData = new FormData();
    formData.append('file', file);

    return this.httpClient.post<any>(
      `${this.baseUrl}/upload_exchange_rates`,
      formData
    );
  }

  updateExchangeRates(file: File) {
    const formData = new FormData();
    formData.append('file', file);

    return this.httpClient.post<any>(
      `${this.baseUrl}/update_exchange_rates`,
      formData
    );
  }

  updateSourcingRfq(payload: any): Observable<any> {
    const url = this.rfqConfig.updateUrl;
    const authPayload = {
      userName: 'admin@mail.com',
      password: 'AATr@ns@2026',
      unitName: 'Bangalore'
    };

    return this.httpClient.post<any>(this.rfqConfig.authUrl, authPayload).pipe(
      switchMap((tokenResponse: any) => {
        const token = this.extractGeneratedToken(tokenResponse);
        if (!token) {
          return throwError(() => new Error('Authentication token not found in token response.'));
        }

        const headers = new HttpHeaders({
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        });

        return this.httpClient.put<any>(url, payload, { headers }).pipe(
          catchError((error: HttpErrorResponse) => {
            // If 401 Unauthorized, try to get a new token and retry
            if (error.status === 401) {
              console.warn('Token expired (401), attempting to refresh token...');
              return this.httpClient.post<any>(this.rfqConfig.authUrl, authPayload).pipe(
                switchMap((newTokenResponse: any) => {
                  const newToken = this.extractGeneratedToken(newTokenResponse);
                  if (!newToken) {
                    return throwError(() => new Error('Failed to refresh authentication token.'));
                  }

                  const newHeaders = new HttpHeaders({
                    'Authorization': `Bearer ${newToken}`,
                    'Content-Type': 'application/json'
                  });

                  return this.httpClient.put<any>(url, payload, { headers: newHeaders });
                })
              );
            }
            return throwError(() => error);
          })
        );
      })
    );
  }

  // getPartPriceHistoryInternal1(internalPartNo: string) {
  //   return this.httpClient.get(`${this.baseUrl}/part_history_ipn?internalPartNumber=${internalPartNo}`);
  // }
  // get_project_parts_part_details_Top_N_Seller(data: any): Observable<any> {
  //   return this.httpClient.post(`${this.baseUrl}/get_project_parts_part_details_Top_N_Seller`, data);
  // }

  UpdateProjectPartMargin(data: any): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/UpdateProjectPartMargin`, data);
  }

  getProjectStatuses(): Observable<any> {
    return this.httpClient.get(`${this.baseUrl}/project_statuses/`);
  }

}


